module.exports = __webpack_public_path__ + "img/1.3da4c68f.jpg";